module.exports = __webpack_public_path__ + "static/img/EP202504081424415.1c3a400.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/technology/detail/EP202504081424415.jpg
// module id = aXS0
// module chunks = 1